export const convertCoordsToInside = (self, { x: out_x, y: out_y }) => {
  const dummy_g_el = self._getDummyGElThrowable();
  const stand_leg_layer_el = self._getStandLegLayerElThrowable();
  let point = self._svg_el.createSVGPoint();
  point.x = out_x;
  point.y = out_y;
  const screen_ctm_inverse = dummy_g_el.getScreenCTM()?.inverse?.();
  if (screen_ctm_inverse == null) {
    throw new Error(`dummy_g 엘리먼트의 ScreenCTM 을 구할 수 없습니다.`);
  }
  point = point.matrixTransform(screen_ctm_inverse);
  const ctm_inverse = stand_leg_layer_el.getCTM()?.inverse?.();
  if (ctm_inverse == null) {
    throw new Error(`stand_leg_layer 엘리먼트의 CTM 을 구할 수 없습니다.`);
  }
  point = point.matrixTransform(ctm_inverse);
  return {
    x: point.x,
    y: point.y,
  };
};
